import type { NavigateFunction } from 'react-router-dom'
import { isEmpty, omit } from 'lodash-es'
import queryString, { type ParsedQuery } from 'query-string'

export const handleClearListFilter = (
  parsedSearch: ParsedQuery | null,
  navigate: NavigateFunction,
  filterName?: string,
) => {
  let queryObject = parsedSearch

  if (!filterName || isEmpty(queryObject)) {
    navigate({ search: queryString.stringify({}) })

    return
  }

  queryObject = omit(parsedSearch, filterName)

  navigate({ search: queryString.stringify(queryObject) })
}
